<script>
import CustomButton from '@/components(new)/UI/Buttons/CustomButton/CustomButton.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    CustomButton
  },
  methods: {
    ...mapActions({
      downloadCartilha: 'usuario/downloadCartilha'
    }),
    async baixarCartilha () {
      try {
        await this.downloadCartilha()
        this.$message({
          message: 'Cartilha baixada com sucesso!',
          type: 'success'
        })
      } catch (error) {
        this.$message({
          message: 'Erro ao baixar a cartilha. Tente novamente.',
          type: 'error'
        })
      }
    }
  }
}
</script>
<template>
  <el-card style="width: 500px" class="m-2">
    <div style="display: flex; justify-content: center;">
      <h2 class="titulo"><i class="far fa-exclamation-triangle" style="color: orange;"></i> <b>Atenção</b></h2>
    </div>
    <hr>
    <div>
      <p>
        Seu cadastro não poderá ser finalizado, para se tornar
        apto ao plano, seguem abaixo as qualificações necessárias,
        ou você pode entrar em contato, por meio dos seguintes canais:
      </p>
      <p>Email: <b>comitegestorabc@sedap.pa.gov.br</b></p>
      <p>Whatsapp: <b>(91) 3251-7914/7903/7906/7901</b></p>
      <div class="actionButtons">
        <CustomButton
          text="Qualificação ao plano ABC+"
          @click="baixarCartilha"
        />
      </div>
    </div>
  </el-card>
</template>

<style lang="scss">
@import '@/scss/_mixins.scss';

.titulo {
  margin: 0;
}

.actionButtons {
  @include column-flex;
  justify-content: center;
  gap: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/App/(authenticated)/modulos/cadastro/formulario-cadastro/praticas/form-praticas/NONE/NONE.vue